import PropTypes from "prop-types"

export const MCancellationPolicy = PropTypes.shape({
  amount: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
})

export const MRoomRate = PropTypes.shape({
  adults: PropTypes.number.isRequired,
  allotment: PropTypes.number.isRequired,
  boardCode: PropTypes.string.isRequired,
  boardName: PropTypes.string.isRequired,
  cancellationPolicies: PropTypes.arrayOf(MCancellationPolicy),
  children: PropTypes.number.isRequired,
  net: PropTypes.string.isRequired,
  packaging: PropTypes.bool.isRequired,
  paymentType: PropTypes.string.isRequired,
  rateClass: PropTypes.string.isRequired,
  rateKey: PropTypes.string.isRequired,
  rateType: PropTypes.string.isRequired,
  rooms: PropTypes.number.isRequired,
})

export const MRoom = PropTypes.shape({
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  rates: PropTypes.arrayOf(MRoomRate)
})

export const MRoomItem = PropTypes.shape({
  description: PropTypes.string,
  id: PropTypes.number.isRequired,
  max_adults: PropTypes.number.isRequired,
  max_children: PropTypes.number,
  max_occupants: PropTypes.number.isRequired,
  min_adults: PropTypes.number.isRequired,
  min_occupants: PropTypes.number.isRequired,
  room_type_description: PropTypes.string.isRequired,
})

export const MRoomRates = PropTypes.shape({
  currency: PropTypes.string.isRequired,
  maxRate: PropTypes.string.isRequired,
  minRate: PropTypes.string.isRequired,
  rooms: PropTypes.arrayOf(MRoom)
})
